var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-container"},[_c('div',{staticClass:"top-bar flex"},[_c('topbar',{staticClass:"flex1"})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }